(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["media-with-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var readMoreButtons = document.querySelectorAll('.readmore');

    readMoreButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        var content = button.nextElementSibling;
        content.classList.toggle('expanded');
        button.textContent = content.classList.contains('expanded') ? 'Read Less' : 'Read More';
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu-accordion"] && !Shopify.designMode) return;
  try {
    class AccordionCustom extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.controller = new AbortController();
    }

    connectedCallback() {
      if (!this.details || !this.summary) return;

      this.setDefaultOpenState();
      this.addEventListeners();
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    addEventListeners() {
      const { signal } = this.controller;

      this.addEventListener('keydown', (e) => this.handleKeyDown(e), { signal });
      this.summary.addEventListener('click', (e) => this.handleClick(e), { signal });
      window.matchMedia('(min-width: 990px)').addEventListener('change', () => this.setDefaultOpenState(), { signal });
    }

    handleClick(event) {
      const isMobile = window.innerWidth < 750;
      const isDesktop = !isMobile;

      if (
        (isMobile && this.dataset.disableOnMobile === 'true') ||
        (isDesktop && this.dataset.disableOnDesktop === 'true')
      ) {
        event.preventDefault();
      }
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && this.dataset.closeWithEscape === 'true') {
        event.preventDefault();
        this.details.open = false;
        this.summary.focus();
      }
    }

    setDefaultOpenState() {
      const isMobile = window.innerWidth < 750;
      this.details.open =
        (isMobile && this.hasAttribute('open-by-default-on-mobile')) ||
        (!isMobile && this.hasAttribute('open-by-default-on-desktop'));
    }
  }

  if (!customElements.get('accordion-custom')) {
    customElements.define('accordion-custom', AccordionCustom);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["rich-text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.block-richtext').forEach(function(block) {
      const readMoreButton = block.querySelector('.readmore');
      const fullDescription = block.querySelector('.js-full-richtext');
      const shortDescription = block.querySelector('.js-truncated-richtext');

      if (!readMoreButton) return;

      readMoreButton.addEventListener('click', function() {
        fullDescription.classList.toggle('open');

        if (fullDescription.classList.contains('open')) {
          shortDescription.style.display = 'none';
          fullDescription.style.display = 'block';
          readMoreButton.textContent = readMoreButton.dataset.textLess;
        } else {
          shortDescription.innerHTML += '...';
          fullDescription.style.display = 'none';
          shortDescription.style.display = 'block';
          readMoreButton.textContent = readMoreButton.dataset.textMore;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
